var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Model",
    {
      attrs: {
        form: _vm.form,
        "init-form": _vm.initForm,
        "is-show": _vm.isShowModel,
        "custom-title": _vm.dialogTitle,
        "auto-height": "",
        "save-item": _vm.saveItem,
        "can-submit": _vm.canSubmit,
      },
      on: {
        "update:isShow": function ($event) {
          _vm.isShowModel = $event
        },
        "update:is-show": function ($event) {
          _vm.isShowModel = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: { model: _vm.form, rules: _vm.rules, size: "small" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "planTaskType",
                rules: _vm.rules.validateChoose,
                label: _vm.$t("doubleWeekPlan.input.taskType"),
                "label-width": _vm.formLabelWidth,
              },
            },
            [
              _c("FormSelect", {
                attrs: {
                  val: _vm.form.planTaskType,
                  options: _vm.formatPlanTypeOptions,
                },
                on: {
                  "update:val": function ($event) {
                    return _vm.$set(_vm.form, "planTaskType", $event)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isTypeSpec
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "customerName",
                    rules: _vm.rules.validateIpt,
                    label: _vm.$t("doubleWeekPlan.table.storeName"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormInput", {
                    attrs: { val: _vm.form.customerName },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "customerName", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isTypeSpec
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "PCD",
                    label: _vm.$t("doubleWeekPlan.table.PCD"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormCascader", {
                    attrs: {
                      "target-form": _vm.form,
                      "key-list": [
                        "cusRegion",
                        "cusRegionCode",
                        "cusCity",
                        "cusCityCode",
                        "cusDistrict",
                        "cusDistrictCode",
                      ],
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isTypeSpec
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "customerAddress",
                    label: _vm.$t("doubleWeekPlan.table.storeAddress"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormTextArea", {
                    attrs: {
                      val: _vm.form.customerAddress,
                      rows: 4,
                      maxlength: 100,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "customerAddress", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("RangePick", {
            attrs: {
              "target-form": _vm.form,
              "key-list": ["planTaskStartTime", "planTaskEndTime"],
              "plan-task-date": _vm.actDateinfo.planTaskDate,
              "actual-plan-task-flag": _vm.actualPlanTaskFlag,
              "label-width": _vm.formLabelWidth,
            },
          }),
          _vm._v(" "),
          _vm.isTypeSpec
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "visitPurpose1",
                    rules: _vm.rules.validateChoose,
                    label: _vm.$t("doubleWeekPlan.input.target1"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      val: _vm.form.visitPurpose1,
                      options: _vm.optConfig.visitPurposeOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "visitPurpose1", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isTypeSpec
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "visitPurpose2",
                    rules: _vm.rules.validateChoose,
                    label: _vm.$t("doubleWeekPlan.input.target2"),
                    "label-width": _vm.formLabelWidth,
                  },
                },
                [
                  _c("FormSelect", {
                    attrs: {
                      val: _vm.form.visitPurpose2,
                      options: _vm.optConfig.visitPurposeOptions,
                    },
                    on: {
                      "update:val": function ($event) {
                        return _vm.$set(_vm.form, "visitPurpose2", $event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "remark",
                rules: _vm.rules.validateIpt,
                label: _vm.$t("doubleWeekPlan.input.desc"),
                "label-width": _vm.formLabelWidth,
              },
            },
            [
              _c("FormTextArea", {
                attrs: { val: _vm.form.remark, rows: 4, maxlength: 300 },
                on: {
                  "update:val": function ($event) {
                    return _vm.$set(_vm.form, "remark", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("TimeConflictModel", {
        ref: "timeConflictModel",
        attrs: { "opt-config": _vm.optConfig },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }